/**
 * Environment utilities for determining the current runtime stage
 */

/**
 * Checks if the current environment is local development
 */
export const isLocal = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' ||
    import.meta.env.DEV
  );
};

/**
 * Checks if the current environment is staging
 */
export const isStaging = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.includes('staging');
};

/**
 * Checks if guides and documentation should be visible
 * Visible in local and staging by default, or if REACT_APP_ENABLE_GUIDES=true
 */
export const shouldShowGuides = (): boolean => {
  // Manual override takes precedence
  if (import.meta.env.VITE_ENABLE_GUIDES === 'true') return true;
  if (import.meta.env.VITE_ENABLE_GUIDES === 'false') return false;

  // Default to showing in local and staging, hiding in prod
  return isLocal() || isStaging();
};

/**
 * Checks if the voice-transcribe / dictation UI on the matter Notes field
 * should be visible. Enabled in local and staging by default, hidden in
 * production until we're comfortable with the end-user experience. Override
 * explicitly via VITE_ENABLE_VOICE_TRANSCRIBE=true|false.
 */
export const shouldShowVoiceTranscribe = (): boolean => {
  if (import.meta.env.VITE_ENABLE_VOICE_TRANSCRIBE === 'true') return true;
  if (import.meta.env.VITE_ENABLE_VOICE_TRANSCRIBE === 'false') return false;

  return isLocal() || isStaging();
};
